import { envs } from '@/app/lib/config/envs';

export const getFullUrl = (relativeUrl: string) => `${envs.baseUrl}${relativeUrl}`;
